const PREFIX = 'ME';

export const RETRIEVE_ME = `${PREFIX}/RETRIEVE`;
export const UPDATE_ME = `${PREFIX}/UPDATE`;
